import { useMemo } from 'react'

import { createStyles } from 'antd-style'

import { jsonFormatHighlight } from '../../utils/jsonFormatHighlight'

import { JsonHighlightViewerProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  summary: {
    cursor: 'pointer'
  },
  pre: {
    margin: 0
  }
}))

export const JsonHighlightViewer = ({ data }: JsonHighlightViewerProps) => {
  const formattedJson = useMemo(() => jsonFormatHighlight(data), [data])

  const { styles } = useStyles()

  return formattedJson ? (
    <details>
      <summary className={styles.summary}>点击展开/折叠</summary>
      <pre
        dangerouslySetInnerHTML={{ __html: formattedJson }}
        className={styles.pre}
      />
    </details>
  ) : null
}
